import React from 'react';
import { NextPage } from 'next';
import { NextSeo } from 'next-seo';
import AddressTemplate from '@components/Address/Address';
import ContactTemplate from '@components/ContactForm/ContactForm';
import HeroTemplate from '@components/ContactHero/Hero';
import FooterTemplate from '@components/Footer/Footer';
import HeaderTemplate from '@components/Header/Header';
import TeamTemplate from '@components/Team/Team';
import useTranslations from '@hooks/useTranslation';
import DividerTemplate from '@ui/Divider/Divider';
import { IS_PROD } from '../constants';

interface IContact {}

const Contacts: NextPage<IContact> = () => {
    const { t } = useTranslations();

    return (
        <>
            <NextSeo title={t('seo.contact.title')} description="" noindex={!IS_PROD} nofollow={!IS_PROD} />
            <HeaderTemplate />
            <HeroTemplate />
            <DividerTemplate />
            <TeamTemplate />
            <DividerTemplate />
            <AddressTemplate />
            <ContactTemplate />
            <FooterTemplate />
        </>
    );
};

export default Contacts;
